import { useState } from "react";
import ClaudeRuns from "@/pages/ClaudeRuns";
import ClaudeChat from "@/components/ClaudeChat";
import { PageHeader } from "@/components/ui-helpers";

export default function ClaudePage() {
  const [tab, setTab] = useState("chat");
  return (
    <div data-testid="claude-page">
      <div className="flex gap-1 px-4 md:px-6 pt-3 border-b border-[var(--border)] text-[13px]">
        {[["chat", "Chat"], ["runs", "Scheduled runs"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`claude-tab-${k}`}
            className={`px-3 py-2 border-b-2 -mb-px transition-colors ${tab === k ? "border-white text-white" : "border-transparent text-neutral-500 hover:text-neutral-300"}`}>{l}</button>
        ))}
      </div>
      {tab === "chat" ? <><PageHeader title="Claude" sub="Chat with your CRM. Claude can read and change leads, tasks, SOPs and settings with your permissions." /><div className="p-4 md:p-6"><ClaudeChat /></div></> : <ClaudeRuns />}
    </div>
  );
}
